import React from "react";
import NoRecord from "../../../components/other/NoRecord";
import { useDispatch, useSelector } from "react-redux";
import { selectClassRestriction } from "../../../redux/reducers/homeReducer";

const WeightClasses = () => {
  const dispatch = useDispatch();
  const { weightClassRestrictions, selectedClassRestriction } = useSelector(
    (state) => state?.homeReducer
  );

  const weightClasses = [
    {
      weightClass: "3lb",
      locomotionBonus: "+1.5 lbs",
      multibotBonus: "+1 lb",
      maxBotWeight: "5 lbs",
    },
    {
      weightClass: "3lb",
      locomotionBonus: "+1.5 lbs",
      multibotBonus: "+1 lb",
      maxBotWeight: "5 lbs",
    },
    {
      weightClass: "3lb",
      locomotionBonus: "+1.5 lbs",
      multibotBonus: "+1 lb",
      maxBotWeight: "5 lbs",
    },
    {
      weightClass: "3lb",
      locomotionBonus: "+1.5 lbs",
      multibotBonus: "+1 lb",
      maxBotWeight: "5 lbs",
    },
  ];

  return (
    <>
      <section class="py-5">
        <div class="container">
          <div class="mt-4">
            <h2 class="section-title mb-4">
              <strong>
                Full rules and restrictions are available here for download.
              </strong>
            </h2>
            <div class="row nav nav-pills mb-3" id="pills-tab" role="tablist">
              {weightClassRestrictions?.length > 0 ? (
                weightClassRestrictions?.map((item, index) => (
                  <div
                    class="col-md-4 mb-3 mb-md-0"
                    onClick={() => dispatch(selectClassRestriction(item))}
                  >
                    {console.log({mapId:item.id,sel:selectedClassRestriction?.id,value:selectClassRestriction?.id == item?.id})}
                    <p class={`mb-0 ${selectedClassRestriction?.id == item?.id ? "active" : ""} `}>
                      <a class="ct_fs_16 ct_text_deocration_under_line">
                        {item?.weight_class_title ?? ""}
                      </a>
                    </p>
                  </div>
                ))
              ) : (
                <NoRecord />
              )}
            </div>
          </div>
        </div>
      </section>

      <section class="ct_rules_and_regulation_main">
        <div class="container">
          <div class="row">
            <div className="col-md-12">
              <div
                dangerouslySetInnerHTML={{
                  __html: selectedClassRestriction?.weight_class_description,
                }}
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default WeightClasses;
